export default "__VITE_ASSET__3caec89d__"